import { MODULE } from "../shared/tagTypes";
import { baseApi } from "./base";

const moduleApi = baseApi
  .enhanceEndpoints({
    addTagTypes: [MODULE],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getModules: builder.query({
        query: (payload) => ({
          url: "/modules",
          params: {
            ...(payload.onlyActive != undefined && {
              onlyActive: payload.onlyActive,
            }),
          },
        }),
        providesTags: [MODULE],
      }),
      getModule: builder.query({
        query: (payload) => ({
          url: `/modules/${payload.id}`,
          params: {},
        }),
        providesTags: [MODULE],
      }),
      createModule: builder.mutation({
        query: (payload) => ({
          url: "/modules",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: [MODULE],
      }),
      updateModule: builder.mutation({
        query: (payload) => ({
          url: `/modules/${payload.id}`,
          method: "PUT",
          body: payload.body,
        }),
        invalidatesTags: [MODULE],
      }),
      deleteModule: builder.mutation({
        query: (payload) => ({
          url: `/modules/${payload.id}`,
          method: "DELETE",
        }),
        invalidatesTags: [MODULE],
      }),
      sortModules: builder.mutation({
        query: (payload) => ({
          url: "/modules/sort",
          method: "POST",
          body: payload,
        }),
      })
    }),

    overrideExisting: false,
  });

export const {
  useGetModulesQuery,
  useLazyGetModulesQuery,
  useGetModuleQuery,
  useLazyGetModuleQuery,
  useCreateModuleMutation,
  useUpdateModuleMutation,
  useDeleteModuleMutation,
  useSortModulesMutation
} = moduleApi;
